import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, computed, inject, input, signal, viewChild } from '@angular/core';

import { ImageComponent, ResizeHtmlImagesPipe, Media } from '@teamfoster/sdk/image';

import { IconComponent } from '@teamfoster/sdk/icon';
import { CookiePreferences, StripEmbedPipe } from '@teamfoster/sdk/cookie-ngrx';
import { SafePipe } from '@teamfoster/sdk/text-utility';
import { EmblaSliderComponent, EmblaSliderNextButtonDirective, EmblaSliderPrevButtonDirective } from '@teamfoster/embla-slider';

@Component({
  selector: 'app-detail-header-gallery',
  imports: [ImageComponent, IconComponent, IconComponent, SafePipe, ResizeHtmlImagesPipe, StripEmbedPipe, NgClass, EmblaSliderComponent],
  templateUrl: './detail-header-gallery.component.html',
  styleUrl: './detail-header-gallery.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DetailHeaderGalleryComponent {
  image = input<Media | null>();
  images = input<Media[] | null>();
  subtitle = input<string>();
  title = input<string>();
  intro = input<string>();
  cookiePreferences = input<CookiePreferences | null>();

  slider = viewChild<EmblaSliderComponent>('slider');

  swiperIndex$ = signal(0);
  cd = inject(ChangeDetectorRef);

  sliderImages = computed(() => {
    const images = this.images() || [];
    return [...images, ...images, ...images];
  });

  singleImage$ = computed(() => {
    const images = this.images();
    if (images?.length === 1) {
      return images[0];
    }
    if ((this.images()?.length || 0) > 1) {
      return undefined;
    }
    return this.image() || undefined;
  });

  preventBack(event: any) {
    if (event?.wheelDeltaX !== 0) {
      event.preventDefault();
    }
  }
}
